import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      className="design-iconfont"
      width={width}
      height={height}
    >
      <g fill={color} fillOpacity=".89999998" fillRule="evenodd">
        <path
          d="M7.03573685,6.31989721 L11.8409977,11.0059525 L10.9682844,11.9008661 L5.12927036,6.20670322 C4.70385532,5.79184297 4.9975286,5.06989721 5.59180717,5.06989721 L21.7332385,5.06989721 L21.7332385,6.3198984 L7.03573685,6.31989721 Z"
          transform="rotate(-90 14.843822 8.603685)"
        />
        <path
          d="M9.59015139,10.4811155 L4.82732185,5.98056547 L5.68583556,5.07202021 L11.522304,10.5870854 C11.9578565,10.9986626 11.666652,11.7311155 11.0672915,11.7311155 L-5.07202021,11.7311155 L-5.07202021,10.4811143 L9.59015139,10.4811155 Z"
          transform="rotate(-90 4.842761 8.519871)"
        />
      </g>
    </svg>
  )
}

const SortAction = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default SortAction
